import React from 'react'
import { BadgeText } from './BadgeText'

type UnreadMessageIconProps = {
  count: number
  color: string
  width?: number | string
  height?: number | string
  className?: string
}

const MAX_DISPLAYED_COUNT = 99

export const UnreadMessageIcon = ({ count, color, width = 20, height = 20, className }: UnreadMessageIconProps) => {
  const isOverflowing = count > MAX_DISPLAYED_COUNT
  const label = isOverflowing ? String(MAX_DISPLAYED_COUNT) : String(count)

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      overflow="visible"
    >
      <path
        d="M19 9.50001C19.0034 10.8199 18.6951 12.1219 18.1 13.3C17.3944 14.7118 16.3097 15.8992 14.9674 16.7293C13.6251 17.5594 12.0782 17.9994 10.5 18C9.18014 18.0034 7.87812 17.6951 6.70001 17.1L1.00002 19L2.90001 13.3C2.30495 12.1219 1.99657 10.8199 2.00001 9.50001C2.00063 7.92177 2.44063 6.37487 3.27073 5.03257C4.10084 3.69027 5.28826 2.60559 6.70001 1.90003C7.87812 1.30496 9.18014 0.996587 10.5 1.00003H11C13.0843 1.11502 15.053 1.99479 16.5291 3.47088C18.0052 4.94698 18.885 6.91567 19 9.00002V9.50001Z"
        fill="white"
        stroke="white"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <BadgeText x="10.41" y="8.6" fontSize={12} fill={color}>
        {label}
      </BadgeText>
      {isOverflowing && (
        // Sits in the chip's padding, past the viewBox, where it is large enough to read
        <path d="M20.2 -1.6V3.4M17.7 0.9H22.7" stroke="white" strokeWidth={1.8} strokeLinecap="round" />
      )}
    </svg>
  )
}
